/* 🤖 this file was generated by svg-to-ts */
export const DfIconEyeOpen16: {
  name: 'eye-open-16';
  data: string;
} = {
  name: 'eye-open-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7.986 14c-2.632 0-5.159-1.597-7.58-4.792a2 2 0 0 1 0-2.416C2.827 3.597 5.354 2 7.986 2c2.63 0 5.164 1.595 7.601 4.786a2 2 0 0 1 0 2.428C13.15 12.404 10.617 14 7.986 14zM8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm.003-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill-rule="evenodd"/></svg>`
};
